import { useContext } from 'react'
import { EmbedContext } from '@src/utility/context/EmbedContext'

const useEmbed = () => {
  const context = useContext(EmbedContext)
  if (!context) {
    throw new Error('useEmbed must be used within EmbedContext.Provider')
  }
  return context
}

export default useEmbed
